export async function loadModuleIfExists(selector, importer) {
    const el = document.querySelector(selector);
    if (!el) return;

    const module = await importer();
    if (typeof module.default === 'function') {
        module.default(el);
    }
}
